import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar } from "@mui/material";
import { getInitials, getLocalISOString } from "../../../_utils/generalUtils";
import cmtIssueStageActions from "../../../_actions/_qmsActions/cmtIssueStageActions";
import { useMemo } from "react";
import {
  Button,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import CmtModal_EditActionItem from "./CmtModal_EditActionItem";
import { statusOptions } from "../_common/qmsConstants";
import { QMS } from "../../../_constants/actionConstants";
import cmtIssueActions from "../../../_actions/_qmsActions/cmtIssueActions";
import CmtModal_AddIssueStagePostAttachments from "./CmtModal_AddIssueStagePostAttachments";
import BadgeContainer from "../../_common/BadgeContainer";
import Badge from "../../_common/Badge";

export default function CmtIssueDetail_Right(props) {
  const { issue, issueStage, selectedStageId, qmsUserId } = props;

  const tabs = [
    { tabId: "updates", label: "Updates/Remarks" },
    { tabId: "actionItems", label: "Action Items" },
  ];

  const [selectedTabId, selectTab] = useState("updates");

  const renderTabContent = () => {
    switch (selectedTabId) {
      case "updates":
        return <CmtIssueDetail_Right_Updates issueStage={issueStage} />;
      case "actionItems":
        return (
          <CmtIssueDetail_Right_ActionItems
            issueStage={issueStage}
            issue={issue}
            selectedStageId={selectedStageId}
            qmsUserId={qmsUserId}
          />
        );
      default:
        return;
    }
  };

  return (
    <CmtIssueDetail_Right_Tabs
      tabs={tabs}
      selectTab={selectTab}
      selectedTabId={selectedTabId}
    >
      {renderTabContent()}
    </CmtIssueDetail_Right_Tabs>
  );
}

function CmtIssueDetail_Right_Tabs(props) {
  const { tabs, selectTab, selectedTabId } = props;

  const renderTab = (tab) => {
    return (
      <li key={tab.tabId} className="nav-item">
        <div
          className={`nav-link border border-secondary border-bottom-0 pointer-cursor py-1 ${
            tab.tabId === selectedTabId ? "active admin-tab--border" : ""
          }`}
          id={tab.tabId + "_tab"}
          data-toggle="tab"
          role="tab"
          onClick={() => selectTab(tab.tabId)}
        >
          {tab.label}
        </div>
      </li>
    );
  };

  return (
    <>
      <ul className="nav nav-tabs border-0" role="tablist">
        {tabs.map((tab) => renderTab(tab))}
      </ul>
      <div className="tab-content pa-tab-content">
        <div
          className="tab-pane fade show active border border-secondary pa-tab-pane p-3"
          role="tabpanel"
        >
          {props.children}
        </div>
      </div>
    </>
  );
}

function CmtIssueDetail_Right_Updates(props) {
  const { issueStage } = props;
  const dispatch = useDispatch();

  const fetching = useSelector((state) => state.qms.fetching);
  const qmsUser = useSelector((state) => state.qms.qmsUser || null);

  const [bodyText, setBodyText] = useState("");
  const [files, setFiles] = useState([]);

  const [showModal_addPostAttachments, _setShowModal_addPostAttachments] =
    useState(false);
  const toggleModal_addPostAttachments = () =>
    _setShowModal_addPostAttachments(!showModal_addPostAttachments);

  const postsRef = useRef(null);

  useEffect(() => {
    // Auto-scroll to bottom of posts
    if (postsRef.current) postsRef.current.scrollTop = postsRef.current.scrollHeight;
  }, []);
  useEffect(() => setBodyText(""), [issueStage]);

  const addFiles = useCallback(
    (filesToAdd) => setFiles(files.concat(filesToAdd)),
    [setFiles, files]
  );

  const removeFileToUpload = useCallback(
    (fileIndex) => {
      // Must shallow-copy
      let _files = [...files];
      _files.splice(fileIndex, 1);
      setFiles(_files);
    },
    [setFiles, files]
  );

  const handleClick_post = async (e) => {
    e.preventDefault();
    if (!qmsUser) return;

    const newIssuePost = {
      issueStagePostId: 0,
      issueStageId: issueStage.issueStageId,
      issueId: issueStage.issueId,
      bodyText,
      bodyTextDraftState: "",
      isSystemGenerated: false,
      isPrivate: true,
      postedOn: getLocalISOString(new Date()),
      postedByQmsUserId: qmsUser.qmsUserId,
      inResponseTo: null,
      upvotes: 0,
      downvotes: 0,
      upvotesBy: "[]",
      downvotesBy: "[]",
    };

    let formData = new FormData();
    files.forEach((file, i) => formData.append(i, file));
    Object.entries(newIssuePost).forEach(([key, value]) => formData.append(key, value));

    await dispatch(
      cmtIssueStageActions.addPost(issueStage.issueId, issueStage.issueStageId, formData)
    );
    setFiles([]);
  };

  const renderPostInput = () => {
    return (
      <div className="card m-2">
        <div className="card-body">
          <div className="form-row">
            <label htmlFor="bodyText" className="mb-0">
              <b>Post Update Remarks/Comments:</b>
            </label>
            <textarea
              name="bodyText"
              id="bodyText"
              className="form-control"
              onChange={(e) => setBodyText(e.target.value)}
              value={bodyText}
              rows="5"
            />
          </div>
          {files.length > 0 && (
            <div className="form-row mt-1">
              <BadgeContainer>
                {files.map((f, index) => (
                  <Badge
                    className="mr-1"
                    key={`fileLabelIndex_${index}`}
                    itemId={index}
                    clickItem={() => {}}
                    deleteItem={removeFileToUpload}
                    label={f.name}
                    showDelete={true}
                  />
                ))}
              </BadgeContainer>
            </div>
          )}
          <div className="form-row float-right mt-2">
            <button
              name="addPostAttachments"
              id="addPostAttachments"
              className="btn btn-secondary mr-2"
              onClick={toggleModal_addPostAttachments}
            >
              <FontAwesomeIcon icon="paperclip" className="fa-fw px-0 mr-1" />
              Attach...
            </button>
            <button
              type="button"
              name="submitPost"
              id="submitPost"
              className="btn btn-primary"
              onClick={handleClick_post}
            >
              Post
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="alert alert-info mb-2 mt-0 p-2 w-100">
        <div className="d-flex flex-row">
          <div className="my-auto align-middle">
            <FontAwesomeIcon icon="info-circle" className="fa-fw mr-2" />
          </div>
          <div className="flex-grow-1 my-auto">
            Only the current and past stage owners can view the updates below. Use the
            Bulletin Board for any public announcements or discussion.
          </div>
        </div>
      </div>
      <div className="issue-stage-details-updates__posts border" ref={postsRef}>
        {issueStage ? (
          (issueStage.posts || []).length > 0 ? (
            _.orderBy(
              issueStage.posts.filter((isp) => !isp.inResponseTo),
              "postedOn",
              "asc"
            ).map((isp, index) => {
              return (
                <div className="d-flex flex-row" key={`issueStagePostKey_${index}`}>
                  <IssuePostRow issueStage={issueStage} issueStagePost={isp} />
                </div>
              );
            })
          ) : (
            <div className="card m-2 bg-lightgray">
              <div className="card-body p-2">No posts yet</div>
            </div>
          )
        ) : fetching ? (
          <div className="card m-2 bg-lightgray">
            <div className="card-body p-2">Loading posts...</div>
          </div>
        ) : (
          <div className="card m-2 bg-lightgray">
            <div className="card-body p-2">(Data N/A)</div>
          </div>
        )}
        {renderPostInput()}
      </div>
      {showModal_addPostAttachments && (
        <CmtModal_AddIssueStagePostAttachments
          showModal={showModal_addPostAttachments}
          toggleModal={toggleModal_addPostAttachments}
          issueStageId={issueStage.issueStageId}
          addFiles={addFiles}
        />
      )}
    </>
  );
}

function IssuePostAvatar(props) {
  const { initials } = props;
  return (
    <div className="m-2">
      <Avatar>{initials}</Avatar>
    </div>
  );
}

function IssuePostVotes(props) {
  const { handleClick_upvote, handleClick_downvote, postId, upvotes, downvotes } = props;

  return (
    <>
      <div className="mr-2">
        <FontAwesomeIcon
          icon={["far", "smile"]}
          className="fa-fw pointer-cursor mr-1"
          onClick={handleClick_upvote(postId)}
        />
        <span className="mr-2 text-small my-auto">{upvotes || 0}</span>
      </div>
      <div className="mr-2">
        <FontAwesomeIcon
          icon={["far", "frown"]}
          className="fa-fw pointer-cursor mr-1"
          onClick={handleClick_downvote(postId)}
        />
        <span className="mr-2 text-small my-auto">{downvotes || 0}</span>
      </div>
    </>
  );
}

function IssuePostRow(props) {
  const { issueStage, issueStagePost: isp } = props;

  const dispatch = useDispatch();
  const [replyBodyText, setReplyBodyText] = useState("");
  const [showReplyInputFor, setReplyInputFor] = useState();

  const qmsUsers = useSelector((state) =>
    issueStage ? state.qms.qmsUsersForIssue[issueStage.issueId] || null : null
  );
  const qmsUser = useSelector((state) => state.qms.qmsUser || null);

  const ispAttachments = useMemo(() => {
    if (!issueStage) return [];
    return (issueStage.attachments || []).filter(
      (isa) => isa.issueStagePostId === isp.issueStagePostId
    );
  }, [issueStage]);

  useEffect(() => {
    setReplyBodyText("");
    setReplyInputFor();
  }, [issueStage]);

  const nestedPosts = useMemo(() => {
    if (!issueStage || !(issueStage.posts || []).length) return {};

    let nested = {};
    issueStage.posts
      .filter((isp) => isp.inResponseTo)
      .forEach((isp) => {
        nested[isp.inResponseTo] = [
          ...(isp.inResponseTo in nested ? nested[isp.inResponseTo] : []),
          isp,
        ];
      });

    return nested;
  }, [issueStage]);

  const getPostedByInitials = useCallback(
    (qmsUserId) => {
      if (!qmsUsers) return "N/A";

      const qmsUser = (qmsUsers || []).find((qu) => qu.qmsUserId === qmsUserId);
      if (!qmsUser) return "N/A";

      return getInitials(qmsUser.fullName) || "N/A";
    },
    [qmsUsers]
  );

  const getPostedBy = useCallback(
    (qmsUserId) => {
      if (!qmsUsers) return "(N/A)";

      const qmsUser = (qmsUsers || []).find((qu) => qu.qmsUserId === qmsUserId);
      if (!qmsUser) return "(N/A)";

      return qmsUser.fullName || "(N/A)";
    },
    [qmsUsers]
  );

  const getReplyCount = useCallback(
    (issueStagePost) => {
      if (!issueStage || !(issueStage.posts || []).length) return 0;

      return issueStage.posts.filter(
        (isp) => isp.inResponseTo === issueStagePost.issueStagePostId
      ).length;
    },
    [issueStage]
  );

  const handleClick_reply = (issueStagePostId) => (e) => {
    e.preventDefault();
    setReplyInputFor(issueStagePostId);
  };

  const handleClick_postReply = (e) => {
    e.preventDefault();

    const newIssuePost = {
      issueStagePostId: 0,
      issueStageId: issueStage.issueStageId,
      issueId: issueStage.issueId,
      bodyText: replyBodyText,
      bodyTextDraftState: "",
      isSystemGenerated: false,
      isPrivate: true,
      postedOn: getLocalISOString(new Date()),
      postedByQmsUserId: qmsUser.qmsUserId,
      inResponseTo: showReplyInputFor,
      upvotes: 0,
      downvotes: 0,
      upvotesBy: "[]",
      downvotesBy: "[]",
    };

    let formData = new FormData();
    Object.entries(newIssuePost).forEach(([key, value]) => formData.append(key, value));

    dispatch(
      cmtIssueStageActions.addPost(issueStage.issueId, issueStage.issueStageId, formData)
    );
  };

  const handleClick_upvote = (issueStagePostId) => (e) => {
    e.preventDefault();
    dispatch(
      cmtIssueStageActions.addPostUpvote(
        issueStage.issueId,
        issueStage.issueStageId,
        issueStagePostId,
        qmsUser.qmsUserId
      )
    );
  };

  const handleClick_downvote = (issueStagePostId) => (e) => {
    e.preventDefault();
    dispatch(
      cmtIssueStageActions.addPostDownvote(
        issueStage.issueId,
        issueStage.issueStageId,
        issueStagePostId,
        qmsUser.qmsUserId
      )
    );
  };

  const handleClick_downloadFile = (isaId, filename) => (e) => {
    e.preventDefault();
    dispatch(cmtIssueStageActions.downloadFile(isaId, filename));
  };

  const renderReplyInput = () => {
    return (
      <div className="d-flex flex-row border-left ml-2">
        <IssuePostAvatar
          initials={getPostedByInitials(qmsUser ? qmsUser.qmsUserId : 0)}
        />
        <div className="card m-2 flex-grow-1">
          <div className="card-body p-2">
            <div className="form-row mx-2">
              <label htmlFor="replyBodyText" className="mb-0">
                <b>Your Reply:</b>
              </label>
              <textarea
                name="replyBodyText"
                id="replyBodyText"
                className="form-control"
                onChange={(e) => setReplyBodyText(e.target.value)}
                value={replyBodyText}
                rows="3"
              />
            </div>
            <div className="form-row mx-2 float-right mt-2">
              <button
                type="button"
                name="submitPost"
                id="submitPost"
                className="btn btn-primary"
                onClick={handleClick_postReply}
              >
                Post
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <IssuePostAvatar
        initials={
          isp.isSystemGenerated ? "auto" : getPostedByInitials(isp.postedByQmsUserId)
        }
      />
      <div className="d-flex flex-column w-100">
        <div className="card m-2">
          <div className="card-header py-1">
            <b>
              {isp.isSystemGenerated
                ? "Auto-Generated"
                : getPostedBy(isp.postedByQmsUserId)}
            </b>{" "}
            on {new Date(isp.postedOn).toLocaleString()}
          </div>
          <div
            className={`card-body py-2${isp.isSystemGenerated ? " bg-lightyellow" : ""}`}
          >
            {isp.bodyText}
            {(ispAttachments || []).length > 0 && (
              <div className="mt-3">
                <em>Attachments:</em>
                <br />
                <div className="d-flex flex-row flex-wrap">
                  {ispAttachments.map((isa) => (
                    <button
                      key={`isaKey_${isp.issueStagePostId}_${isa.issueStageAttachmentId}`}
                      name="issueStageAttachment"
                      id={`isaKey_${isp.issueStagePostId}_${isa.issueStageAttachmentId}`}
                      className="btn btn-sm btn-link px-0 py-1 mr-2 text-left"
                      onClick={handleClick_downloadFile(
                        isa.issueStageAttachmentId,
                        isa.originalFilename
                      )}
                    >
                      {isa.originalFilename}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
          {!isp.isSystemGenerated && (
            <div className="card-footer py-1 d-flex flex-row">
              <div
                className="mr-1 pointer-cursor"
                onClick={handleClick_reply(isp.issueStagePostId)}
              >
                <FontAwesomeIcon icon="reply" className="fa-fw mr-1" />
                <span className="mr-4 text-small my-auto">{getReplyCount(isp)}</span>
              </div>
              <IssuePostVotes
                handleClick_upvote={handleClick_upvote}
                handleClick_downvote={handleClick_downvote}
                postId={isp.issueStagePostId}
                upvotes={isp.upvotes}
                downvotes={isp.downvotes}
              />
            </div>
          )}
        </div>
        {isp.issueStagePostId in nestedPosts &&
          _.orderBy(nestedPosts[isp.issueStagePostId], "postedOn", "asc").map(
            (nisp, innerIndex) => {
              return (
                <div
                  className="d-flex flex-row border-left ml-2"
                  key={`issueStagePostKey_inner_${innerIndex}`}
                >
                  <IssuePostAvatar
                    initials={getPostedByInitials(nisp.postedByQmsUserId)}
                  />
                  <div className="card flex-grow-1 m-2">
                    <div className="card-header py-1">
                      <b>{getPostedBy(nisp.postedByQmsUserId)}</b> on{" "}
                      {new Date(nisp.postedOn).toLocaleString()}
                    </div>
                    <div className="card-body py-2">{nisp.bodyText}</div>
                    <div className="card-footer py-1 d-flex flex-row">
                      <IssuePostVotes
                        handleClick_upvote={handleClick_upvote}
                        handleClick_downvote={handleClick_downvote}
                        postId={nisp.issueStagePostId}
                        upvotes={nisp.upvotes}
                        downvotes={nisp.downvotes}
                      />
                    </div>
                  </div>
                </div>
              );
            }
          )}
        {showReplyInputFor === isp.issueStagePostId && renderReplyInput()}
      </div>
    </>
  );
}

function CmtIssueDetail_Right_ActionItems(props) {
  const { issue, selectedStageId, qmsUserId } = props;

  const dispatch = useDispatch();

  const [modalState_editActionItem, setModalState_editActionItem] = useState({
    showModal: false,
    data: null,
  });
  const toggleModal_editActionItem = () =>
    setModalState_editActionItem({
      ...modalState_editActionItem,
      showModal: !modalState_editActionItem.showModal,
    });

  const handleChange_status = (issueActionItemId, statusValue) => (e) => {
    e.preventDefault();
    dispatch({
      type: QMS.ISSUE.ACTION_ITEMS.UPDATE_CLIENT,
      issueId: issue.issueId,
      issueActionItemId,
      fieldsToUpdate: { statusValue },
    });
    dispatch(cmtIssueActions.update(issue.issueId));

    // Reload issue with updated issueStageSnippets
    dispatch(cmtIssueActions.get(issue.issueId));
  };

  const handleClick_add = (e) => {
    e.preventDefault();
    setModalState_editActionItem({
      showModal: true,
      data: { issue, qmsUserId, selectedStageId },
    });
  };

  return (
    <React.Fragment>
      <div className="d-flex flex-row mb-0 px-2">
        <div className="d-flex flex-row" style={{ width: "55px" }}>
          <span>
            <b>Id</b>
          </span>
          <div
            className="pointer-cursor"
            onClick={() =>
              alert(
                "Action Item Ids are auto-assigned, and may not be sequential or increment uniformly within an issue."
              )
            }
          >
            <FontAwesomeIcon icon="info-circle" className="ml-1 text-muted" />
          </div>
        </div>
        <div>
          <span className="pl-1">
            <b>Status, Action Item</b>
          </span>
        </div>
      </div>
      {issue &&
        issue.actionItems &&
        issue.actionItems.map((iai, index) => {
          const color =
            iai.statusValue === 2
              ? "warning"
              : iai.statusValue === 3
              ? "success"
              : "secondary";
          const icon =
            iai.statusValue === 2
              ? "hiking"
              : iai.statusValue === 3
              ? "check"
              : "bookmark";
          return (
            <React.Fragment key={`issueActionItemKey_${index}`}>
              <div className="card mb-2">
                <div className="card-body p-2">
                  <div className="d-flex flex-row justify-content-between mb-0">
                    <div className="d-flex flex-row">
                      <div className="my-auto mr-1 pl-0" style={{ width: "55px" }}>
                        <span className="my-auto font-weight-bold mr-2">
                          <small>#</small>
                          {iai.issueActionItemId}
                        </span>
                      </div>
                      <div className="my-auto mr-2">
                        <UncontrolledDropdown group className="py-0">
                          <Button
                            style={{ width: "130px" }}
                            size="sm"
                            color={color}
                            className="text-left"
                          >
                            <FontAwesomeIcon icon={icon} className="fa-fw mr-2" />
                            {iai.statusDisplayName}
                          </Button>
                          <DropdownToggle caret size="sm" outline color={color} />
                          <DropdownMenu>
                            {statusOptions.map((so) => (
                              <DropdownItem
                                key={`actionItemStatusOptionKey_${so.value}`}
                                onClick={handleChange_status(
                                  iai.issueActionItemId,
                                  so.value
                                )}
                              >
                                <small>{so.label}</small>
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                      <div className="my-auto">
                        <span className="my-auto">{iai.title}</span>
                      </div>
                    </div>
                    <div className="flex-shrink-0 mr-2 my-auto align-content-end">
                      <button className="btn btn-sm btn-secondary p-1 mr-1">
                        <FontAwesomeIcon icon="info-circle" className="fa-fw mr-1" />
                        Info
                      </button>
                      <button className="btn btn-sm btn-danger p-1">
                        <FontAwesomeIcon icon="times" className="fa-fw mr-1" />
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      <button
        name="addActionItem"
        id="addActionItem"
        className="btn btn-sm btn-secondary"
        onClick={handleClick_add}
      >
        <FontAwesomeIcon icon="plus" className="mr-2" />
        New Action Item...
      </button>
      {modalState_editActionItem.showModal && (
        <CmtModal_EditActionItem
          modalState={modalState_editActionItem}
          toggleModal={toggleModal_editActionItem}
        />
      )}
    </React.Fragment>
  );
}
